import { isEmpty } from "lodash";
import IconItem from "modules/common/icon/IconItem";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import corner1 from "assets/img/illustrations/corner-2.png";
import Background from "modules/common/Background";
const colorPicker = [
  "warning",
  "info",
  "success",
  "danger",
  "primary",
  "secondary",
  "warning",
];

function ProductivityStats({ callingData }) {
  const convertTimeToSeconds = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const convertSecondsToTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const dataArray =!isEmpty(callingData?.statsByTag)&&Object.values(callingData?.statsByTag).reduce(
    (acc, entry) => {
      Object.keys(entry).forEach((key) => {
        if (key === "total_talk_time") {
          acc[key] = (acc[key] || 0) + convertTimeToSeconds(entry[key]);
        } else {
          acc[key] = (acc[key] || 0) + entry[key];
        }
      });
      return acc;
    },
    {}
  );

  if (dataArray["total_talk_time"] !== undefined) {
    dataArray["total_talk_time"] = convertSecondsToTime(
      dataArray["total_talk_time"]
    );
  }

  return (
    <div className="mb-3">
      <div className="h-100">
        <div className="d-flex gap-2 flex-row">
          {Object.keys(dataArray).map((stat, index) => (
            <div key={dataArray[stat].id} className="flex-1">
              <Card className="h-100">
                <Card.Body>
                  <Background
                    image={corner1}
                    style={{
                      borderTopRightRadius: "0.375rem",
                      borderBottomRightRadius: "0.375rem",
                    }}
                  />
                  <Row className="flex-between-center">
                    <Col className="d-lg-block flex-between-center me-n4">
                      <div className="d-flex flex-row align-items-center">
                        <IconItem
                          tag="div"
                          icon="phone"
                          bg={`soft-${colorPicker[index]}`}
                          color={colorPicker[index]}
                          size="lg"
                          iconClass="fs--2"
                          className="me-2 shadow-none"
                        />
                        <h6 className="mb-2 text-900">
                          {stat.replaceAll("_", " ").charAt(0).toUpperCase() +
                            stat.replaceAll("_", " ").slice(1).toLowerCase()}
                        </h6>
                      </div>
                      <h4 className="fs-3 ps-5 fw-normal text-700 mb-0">
                        {dataArray[stat]}
                      </h4>
                    </Col>
                    <Col xs="auto" className="h-100"></Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductivityStats;
